import { axios } from '@Root/API'

export const getAll = id => {
	return axios.get(`subject-modules/${id}`)
}
